/**
 * Utility function to display a cookie banner.
 */
export const displayCookieBanner = () => {
	const cookiePopup = document.getElementById('cookieBanner');
	const hasAcceptedCookies = localStorage.getItem('gdpr_cookies_accepted') ? true : false;
	if (cookiePopup && !hasAcceptedCookies) {
		cookiePopup.classList.add('is-visible');
		const acceptButton = cookiePopup.querySelector('#cookieBannerAccept');
		acceptButton.addEventListener('click', () => {
			localStorage.setItem('gdpr_cookies_accepted', true);
			cookiePopup.remove();
		});
	} else if (cookiePopup && hasAcceptedCookies) {
		cookiePopup.remove();
	}
};
